module.exports = __webpack_public_path__ + "img/space-and-stars.894defd4.png";